import { render, staticRenderFns } from "./SMenuMobileComp.vue?vue&type=template&id=6750d2dd&"
import script from "./SMenuMobileComp.vue?vue&type=script&lang=js&"
export * from "./SMenuMobileComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports